import { BaseModel } from "sjs-base-model";

export default class ApiKeyListModel extends BaseModel {
    apiId = '';
    userId = '';
    createDate= '';
    expiryDate= '';

    constructor(data) {
        super();
        this.update(data);
    }
}